import { createServerAction, extract } from '@exonet/jsonapi-fetcher/lib/resources';

// DataObjects.
import { LocalSettingDataObject } from '@exonet/jsonapi-data-collections';

// App constants.
import { constants } from 'app/client/store/reducers/app';

// Contracts.
import { getLocalSettings, updateLocalSetting } from 'app/client/modules/Core/contracts';

const mapStateToProps = ({ app, api }) => ({
  settings: app.customer ? extract(getLocalSettings(), api).get() : false,
  theme: app.theme,
  autoSwitchTheme: app.autoSwitchTheme,
});

const mapDispatchToProps = (dispatch) => ({
  actions: {
    setTheme: async (settings, payload) => {
      // Dispatch the call to update a setting value.
      const result = await dispatch({ type: constants.setTheme, payload });

      if (typeof settings.getByKey === 'undefined') {
        return result;
      }

      const setting = settings.getByKey('app.theme').first();

      const dataObject = new LocalSettingDataObject()
        .setId(setting.id())
        .attributes({ value: payload });

      // Dispatch the call to update a setting value.
      return dispatch(createServerAction(updateLocalSetting(dataObject)).patch());
    },

    setAutoSwitchTheme: async (settings, payload) => {
      // Dispatch the call to update a setting value.
      const result = await dispatch({ type: constants.setAutoSwitchTheme, payload });

      if (typeof settings.getByKey === 'undefined') {
        return result;
      }

      const setting = settings?.getByKey('app.autoSwitchTheme').first();

      const dataObject = new LocalSettingDataObject()
        .setId(setting.id())
        .attributes({ value: payload });

      // Dispatch the call to update a setting value.
      return dispatch(createServerAction(updateLocalSetting(dataObject)).patch());
    },
  },
});

export default [mapStateToProps, mapDispatchToProps];
